// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2mvQU","inverted":"Button-module--inverted--2Q30T"};